import NavBar from "../components/navBar";
import Footer from "../components/footer";

export default function TermsAndAgreement() {
    return (
        <div>
            <NavBar />
            <div style={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                minHeight: "100vh", 
                padding: "20px",
            }}>
                <div style={{ 
                    backgroundColor: "white", 
                    padding: "30px", 
                    borderRadius: "8px", 
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)", 
                    maxWidth: "1000px",
                    width: "100%",
                    lineHeight: "2",
                    fontFamily: "Arial, sans-serif",
                    textAlign: "start",
                    color: "#333",
                }}>
                    <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
                        SweetwoodFlora Purchase Agreement and Disclaimer
                    </h2>
                    <p style={{textAlign: "center"}}>
                        By completing a purchase on SweetwoodFlora's website, you agree to the following terms and conditions:
                    </p>
                    <ol>
                        <li>
                            <strong>Non-Refundable Policy:</strong> All products purchased on this website are non-refundable. SweetwoodFlora only accepts partial refunds (equal to one-third of the sale price) if cancellation is requested with at least 24 hours' notice before the delivery date. This policy protects the time and material costs invested by our florists.
                        </li>
                        <li>
                            <strong>Liability Disclaimer:</strong> SweetwoodFlora is not responsible for any damage, medical conditions, or allergic reactions caused by our products. Customers are advised to review product descriptions and ingredients carefully. Any consumption of our products is strictly at the customer's own risk, and SweetwoodFlora will not be held liable for any related consequences.
                        </li>
                        <li>
                            <strong>Product Representation:</strong> SweetwoodFlora makes every effort to ensure that delivered products closely match the images on our website. However, due to the nature of floral arrangements and seasonal availability, we cannot guarantee a 100% match in color, size, shape, or wrapping. We commit to achieving at least a 90% resemblance in flower color, species, and wrapping.
                        </li>
                        <li>
                            <strong>Delivery Restrictions:</strong> Orders placed outside of our designated delivery range or to locations unsupported by our shipping methods will be declined and refunded. Customers are advised to verify delivery availability before placing an order.
                        </li>
                        <li>
                            <strong>Payment Security and Fraud:</strong> SweetwoodFlora utilizes third-party secure payment processors to protect customer transactions. However, in the event of payment fraud, SweetwoodFlora is not responsible and cannot offer compensation.
                        </li>
                        <li>
                            <strong>Right to Refuse Transactions:</strong> SweetwoodFlora reserves the right to accept or decline any transaction at our discretion. This includes orders flagged for any reason, such as location or payment issues.
                        </li>
                        <li>
                            <strong>Tax Policy:</strong> All purchases are subject to a local tax fee of 8.25% based on SweetwoodFlora's store location. As we exclusively offer local deliveries, tax calculations are not adjusted for the purchaser's location. For any shipping products, SweetwoodFlora will refund orders that cannot meet these terms.
                        </li>
                        <li>
                            <strong>Local Delivery Policy:</strong> Products marked as "local delivery only" are not eligible for shipping outside our delivery range. Orders placed with an unsupported shipping address will be automatically declined and refunded.
                        </li>
                        <li>
                            <strong>Product Life Cycle Guarantee:</strong> Unless otherwise specified in the product description, SweetwoodFlora does not guarantee the life span of its products. We ensure that products are delivered in good condition. In the event of a dispute, SweetwoodFlora reserves the right to determine whether the delivered product meets our quality standards.
                        </li>
                        <li>
                            <strong>Non-Edible Products:</strong> SweetwoodFlora does not market or sell edible products. Any ingestion of our products, whether by adults or children, is strictly at the customer's own risk. SweetwoodFlora disclaims all responsibility for consequences arising from accidental or intentional ingestion.
                        </li>
                        <li>
                            <strong>Force Majeure:</strong> SweetwoodFlora is not liable for delays or failures in delivery caused by events beyond our control, including but not limited to natural disasters, weather conditions, transportation disruptions, or labor disputes.
                        </li>
                        <li>
                            <strong>Customer Responsibility:</strong> It is the customer's responsibility to provide accurate and complete delivery information. SweetwoodFlora is not responsible for failed deliveries due to incorrect or incomplete addresses provided by the customer.
                        </li>
                        <li>
                            <strong>Governing Law:</strong> This agreement is governed by the laws of the state in which SweetwoodFlora operates. Any disputes arising from purchases will be resolved in the jurisdiction of SweetwoodFlora's business location.
                        </li>
                    </ol>
                    <p style={{ marginTop: "20px", fontSize: "0.9em", textAlign: "center" }}>
                        By proceeding with a purchase, you acknowledge that you have read, understood, and agreed to these terms and conditions. SweetwoodFlora reserves the right to amend this agreement at any time without prior notice.
                    </p>
                </div>
            </div>
            <Footer />
        </div>
    );
}
